// extracted by mini-css-extract-plugin
export default {"checkbox":"_2UKKy","align-items-center":"_1WybL","alignItemsCenter":"_1WybL","label":"_38PKw"};